//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { SamplingCampaignExportType } from '@campaigns/types/sampling/SamplingCampaignExportTypes';

export const SamplingCampaignExportLabels = {
  [SamplingCampaignExportType.All]: 'All Campaign Data',
  [SamplingCampaignExportType.Products]: 'Product Summary',
  [SamplingCampaignExportType.Reviews]: 'Reviews',
  [SamplingCampaignExportType.Social]: 'Social Content',
  [SamplingCampaignExportType.PostSurvey]: 'Post Survey',
} as const;

export const SamplingCampaignExportPath = {
  [SamplingCampaignExportType.All]: '/export',
  [SamplingCampaignExportType.Reviews]: '/reviews/export',
  [SamplingCampaignExportType.Social]: '/social/export',
  [SamplingCampaignExportType.Products]: '/products/export',
  [SamplingCampaignExportType.PostSurvey]: '/surveys/aggregated-results/export',
} as const;

export const FileExtensions = {
  Csv: 'csv',
  Zip: 'zip',
} as const;

export const ContentTypes = {
  Csv: 'text/csv;charset=utf-8;',
  Zip: 'application/zip',
} as const;
